<template>
  <div class="out-storage-scan">
    <div class="page-header">
      <el-button
          type="text"
          icon="el-icon-back"
          @click="goBack"
          size="medium"
      >
        返回首页
      </el-button>
    </div>
    <el-tabs v-model="activeName" type="card" class="barcode-tabs" @tab-click="handleTabClick">
      <!-- 手机扫 tab -->
      <!-- 手机扫 tab 内容（替换原来的 <el-tab-pane label="手机扫" name="first"> 内部） -->
      <el-tab-pane label="手机扫" name="first">
        <div class="tab-content phone-tab">
          <h3 class="tab-title">手机摄像头扫码出库</h3>

          <!-- 1. 选择任务（放在最上面） -->
          <div class="task-select-area">
            <el-select
                v-model="phoneTaskId"
                placeholder="请选择出库任务"
                filterable
                clearable
                style="width: 100%; max-width: 400px;"
                @change="phoneOnTaskChange"
            >
              <el-option
                  v-for="item in cktaskList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </div>

          <!-- 2. 摄像头扫描区域（扫码放在任务下面，核心位置） -->
          <div class="scanner-section" v-show="phoneTaskId">
            <div class="scanner-wrapper">
              <div id="phone-reader" class="reader-container"></div>
              <div class="scan-overlay" v-show="phoneScanning">
                <div class="scan-line horizontal"></div>
              </div>
            </div>

            <!-- 扫描控制按钮（横排，手机端易点） -->
            <div class="controls">
              <el-button
                  type="primary"
                  size="medium"
                  :disabled="phoneScanning || !phoneCameras.length"
                  @click="phoneStartScanning"
                  style="flex: 1;"
              >
                开始
              </el-button>
              <el-button
                  type="danger"
                  size="medium"
                  :disabled="!phoneScanning"
                  @click="phoneStopScanning"
                  style="flex: 1;margin-left: 0px"
              >
                停止
              </el-button>
              <el-button
                  type="info"
                  size="medium"
                  @click="phoneSwitchCamera"
                  :disabled="!phoneCameras.length || phoneCameras.length <= 1"
                  style="flex: 1;margin-left: 0px"
              >
                切换
              </el-button>
            </div>

            <!-- 当前状态 -->
            <div class="status-box" v-if="phoneStatusMessage">
              {{ phoneStatusMessage }}
            </div>
            <el-alert
                v-if="phoneErrorMessage"
                title="提示"
                type="error"
                :description="phoneErrorMessage"
                show-icon
                :closable="true"
                @close="phoneErrorMessage = ''"
                style="margin-top: 10px;"
            />
          </div>

          <!-- 3. 设备列表（放在最下面） -->
          <div class="device-section" v-if="phoneTaskId && phoneDeviceList.length">
            <h4 class="list-title">出库进度列表</h4>
            <el-table
                :data="phoneDeviceList"
                border
                stripe
                style="width: 100%;"
                height="auto"
                :max-height="400"
            >
              <el-table-column label="设备" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ formatepid(scope.row.pid) }}
                </template>
              </el-table-column>
              <el-table-column prop="state" label="差额" width="90" align="center">
                <template slot-scope="scope">
         <span
             :class="{
                      'completed': (scope.row.num || 0) === (scope.row.state || 0),
                      'remaining': (scope.row.num || 0) > (scope.row.state || 0)
                    }"
         >
                    {{
             (scope.row.num || 0) === (scope.row.state || 0)
                 ? '已完成'
                 : (scope.row.num || 0) - (scope.row.state || 0)
           }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 未选任务时的提示 -->
          <div v-if="!phoneTaskId" class="no-task-tip">
            请先在上方选择出库任务，才能开始扫描和查看列表
          </div>
        </div>
      </el-tab-pane>
      <!-- 扫码枪 tab -->
      <el-tab-pane label="扫码枪" name="second"  v-if="devicetype=='pc'">
        <div class="tab-content">
          <div class="scanner-card">
            <div class="card-header">
              <span class="header-emoji">📟</span>
              <h3>扫码枪快速录入 - 出库任务：{{ gunSelectedTaskName }}</h3>
            </div>

            <el-select
                v-model="gunTaskId"
                placeholder="请选择出库任务"
                style="margin-bottom: 20px; width: 300px;"
                @change="gunOnTaskChange"
            >
              <el-option
                  v-for="item in cktaskList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>

            <el-row :gutter="20">
              <el-col :span="14">
                <div class="left-panel">
                  <h4 class="panel-title">设备出库进度</h4>
                  <el-table
                      :data="gunDeviceList"
                      border
                      stripe
                      style="width: 100%"
                      height="480"
                  >
                    <el-table-column label="设备" min-width="180" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{ formatepid(scope.row.pid) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="num" label="应出" width="120" align="center"/>
                    <el-table-column prop="state" label="已出" width="120" align="center">
                      <template slot-scope="scope">
                        <span :class="{ 'out-highlight': scope.row.state >= scope.row.num }">
                          {{ scope.row.state || 0 }}
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>

              <el-col :span="10">
                <div class="right-panel">
                  <h4 class="panel-title">扫码出库</h4>

                  <el-input
                      v-model="scanCode"
                      ref="scanInput"
                      placeholder="对准条码扫描 → 自动处理"
                      clearable
                      autofocus
                      class="scan-input-large"
                      @keydown.enter.native="gunHandleScanEnter"
                  />

                  <div class="current-status" :class="gunStatus">
                    <span class="status-emoji">
                      <template v-if="gunStatus === 'loading'">⌛️</template>
                      <template v-else-if="gunStatus === 'success'">✅</template>
                      <template v-else-if="gunStatus === 'warning'">⚠️</template>
                      <template v-else-if="gunStatus === 'error'">❌</template>
                      <template v-else>⏳</template>
                    </span>
                    <span class="status-text">{{ gunStatusText || '等待扫描...' }}</span>
                  </div>

                  <div class="guide-text">
                    <p>扫码枪扫描后自动确认</p>
                    <p>成功会更新左侧进度</p>
                  </div>

                  <el-button type="primary" plain @click="gunFocusInput" class="focus-btn">
                    点击聚焦输入框
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="批量出库" name="batch" v-if="devicetype=='pc'">
        <div class="tab-content">
          <div class="scanner-card">
            <div class="card-header">
              <span class="header-emoji">📟</span>
              <h3>批量出库 - 出库任务：{{ gunSelectedTaskName }}</h3>
            </div>

            <el-select
                v-model="gunTaskId"
                placeholder="请选择出库任务"
                style="margin-bottom: 20px; width: 300px;"
                @change="gunOnTaskChange"
            >
              <el-option
                  v-for="item in cktaskList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>

            <el-row :gutter="20">
              <el-col :span="14">
                <div class="left-panel">
                  <h4 class="panel-title">设备出库进度</h4>
                  <el-table
                      :data="gunDeviceList"
                      border
                      stripe
                      style="width: 100%"
                      height="480"
                  >
                    <el-table-column label="设备" min-width="180" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{ formatepid(scope.row.pid) }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="num" label="应出" width="120" align="center"/>
                    <el-table-column prop="state" label="已出" width="120" align="center">
                      <template slot-scope="scope">
                        <span :class="{ 'out-highlight': scope.row.state >= scope.row.num }">
                          {{ scope.row.state || 0 }}
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>

              <el-col :span="10">
                <div class="right-panel">
                  <h4 class="panel-title">扫码出库</h4>

                  <el-input
                      v-model="batchCode"
                      ref="scanInput"
                      type="textarea"
                      rows="10"
                      maxlength="5000"
                      placeholder="放入序列号按回车处理"
                      clearable
                      autofocus
                      class="scan-input-large"
                      @keydown.enter.native="gunHandleBatchEnter"
                  />
                  <div class="current-status" :class="gunStatus">
                    <span class="status-emoji">
                      <template v-if="gunStatus === 'loading'">⌛️</template>
                      <template v-else-if="gunStatus === 'success'">✅</template>
                      <template v-else-if="gunStatus === 'warning'">⚠️</template>
                      <template v-else-if="gunStatus === 'error'">❌</template>
                      <template v-else>⏳</template>
                    </span>
                    <span class="status-text">{{ gunStatusText || '等待出库...' }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="溯源" name="trace"  v-if="devicetype=='pc'">
        <div class="tab-content">
          <div class="scanner-card">
            <h3 class="card-title">产品溯源</h3>

            <!-- 扫描输入区：查询到结果后隐藏 -->
            <div v-if="showScanner">


              <div class="current-status" :class="traceStatus">
                  <span class="status-emoji">
                    <template v-if="traceStatus === 'loading'">⌛️</template>
                    <template v-else-if="traceStatus === 'success'">✅</template>
                    <template v-else-if="traceStatus === 'warning'">⚠️</template>
                    <template v-else-if="traceStatus === 'error'">❌</template>
                    <template v-else>⏳</template>
                  </span>
                <span class="status-text">{{ traceStatusText || '等待输入...' }}</span>
              </div>

              <div class="guide-text">
                <el-input
                    v-model="traceCode"
                    ref="traceInput"
                    placeholder="输入后回车 → 自动查询"
                    clearable
                    autofocus
                    style="width: 50%"
                    class="scan-input-large"
                    @keydown.enter.native="gunTraceEnter"
                />
                <p>回车 后自动查询设备溯源信息</p>
                <el-button type="primary" plain @click="traceFocusInput">
                  点击聚焦输入框
                </el-button>
              </div>


            </div>

            <!-- 溯源结果 -->
            <div class="trace-result" v-if="traceResult">
              <el-card class="device-info-card">
                <div slot="header">
                  <span>设备基本信息</span>
                </div>
                <div class="info-row">
                  <span class="label">设备PID：</span>
                  <span class="value">{{ traceResult.pid || '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">设备名称：</span>
                  <span class="value">{{ traceResult.name || '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">规格型号：</span>
                  <span class="value">{{ traceResult.code || '--' }}</span>
                </div>
                <div class="info-row">
                  <span class="label">当前状态：</span>
                  <el-tag :type="traceResult.status === '在库' ? 'success' : 'warning'">
                    {{ traceResult.status || '未知' }}
                  </el-tag>
                </div>
              </el-card>

              <div class="history-section" v-if="traceResult.history && traceResult.history.length">
                <h4 class="section-title">出入库节点历史</h4>
                <el-timeline>
                  <el-timeline-item
                      v-for="(event, index) in traceResult.history"
                      :key="index"
                      :timestamp="event.state"
                      :color="event.type === '1' ? '#67C23A' : '#E6A23C'"
                      placement="top"
                  >
                    <el-card class="history-card" shadow="hover">
                      <div class="event-content">
                        <el-tag
                            :type="event.type === '1' ? 'success' : 'warning'"
                            size="small"
                            effect="dark"
                        >
                          {{ formatecktype(event.sstype) }}
                        </el-tag>

                        <el-tag
                            type="info"
                            size="small"
                            effect="plain"
                            class="company-tag"
                        >
                          {{ formatecid(event.cid) }}
                        </el-tag>
                      </div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>

              <div v-else class="no-history">
                暂无出入库历史记录
              </div>

              <div style="text-align: center; margin-top: 30px;">
                <el-button type="primary" plain @click="resetTrace">
                  重新溯源
                </el-button>
              </div>
            </div>

            <div v-if="!showScanner && !traceResult" class="no-result-tip">
              暂无查询结果，请扫描条码
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {Html5Qrcode} from 'html5-qrcode'

export default {
  data() {
    return {
      devicetype: 'pc',
      activeName: 'first',
      batchCode: '',
      // 公共：任务列表 + 商品列表（两个 tab 共用）
      cktaskList: [],
      productList: [],

      // 手机扫 tab 数据（独立）
      phoneTaskId: undefined,
      phoneDeviceList: [],
      phoneScanning: false,
      phoneCameras: [],
      phoneCurrentCameraId: null,
      phoneStatusMessage: '',
      phoneErrorMessage: '',
      phoneScanner: null,

      // 扫码枪 tab 数据（独立）
      gunTaskId: undefined,
      gunSelectedTaskName: '',
      gunDeviceList: [],
      scanCode: '',
      gunStatus: '',
      gunStatusText: '等待扫描...',
      comList: [],
      rktypeList: [],
      traceResult: null,
      showScanner: true,              // 控制扫描区域显示/隐藏
      traceCode: '',
      traceStatus: '',
      traceStatusText: '等待扫描...'
    }
  },

  mounted() {
    this.gettask()
    this.getproductList()
    this.getDic();
    this.getcom();
    // 初始化手机扫扫描器
    this.phoneInitScanner()
    this.devicetype = localStorage.getItem('deviceType')
    // 扫码枪初始聚焦（可选）
    this.$nextTick(() => {
      if (this.activeName === 'second') this.gunFocusInput()
    })
  },

  beforeDestroy() {
    this.phoneStopScanning()
  },

  methods: {
    handleTabClick(tab, event) {
      if (tab.name === 'second'||tab.name === 'batch'||tab.name === 'trace') {
      this.gunTaskId = undefined
      this.gunSelectedTaskName = ''
      this.gunDeviceList = []
      this.scanCode = ''
      this.gunStatus = ''
      this.gunStatusText = '等待扫描...'
      this.traceResult = null
      this.showScanner = true             // 控制扫描区域显示/隐
      this.traceCode = ''
      this.traceStatus = ''
      this.gunStatusText = '等待扫描...'}
    },
    gunHandleBatchEnter() {

      const code = this.batchCode.trim()
      if (!code) return
      if (!this.gunTaskId) {
        this.gunStatus = 'warning'
        this.gunStatusText = '请先选择出库任务'
        return
      }

      this.gunStatus = 'loading'
      this.gunStatusText = '处理中...'

      this.$request.postHttp({
        url: "/basic/ckOrderBatch",
        data: {pid: this.gunTaskId, cs: code},
        success: (data) => {
          if (data.code == 200) {

            this.gunStatus = 'success'
            this.gunStatusText = '已处理，列表刷新'
          } else {
            this.gunStatus = 'error'
            this.gunStatusText = data.msg
          }
          this.gunGetDeviceList()
        },
        error: (err) => {
          console.error('扫码枪出库失败', err)
          this.gunGetDeviceList()
          this.gunStatus = 'warning'
          this.gunStatusText = err.msg
        }
      })

      this.batchCode = ''
      this.$nextTick(() => this.gunFocusInput())
    },
    resetTrace() {
      this.traceResult = null
      this.showScanner = true
      this.traceStatus = ''
      this.traceStatusText = '等待扫描...'
    },
    // 扫码枪方法
    traceFocusInput() {
      this.$refs.traceInput?.focus()
    },

    gunTraceEnter() {
      const code = this.traceCode.trim()
      if (!code) return

      this.traceStatus = 'loading'
      this.traceStatusText = '查询中...'

      this.handleBarcode(code)

      this.traceCode = ''
      this.$nextTick(() => this.traceFocusInput())
    },
    handleBarcode(barcode) {
      if (!barcode || barcode.length < 6) return

      this.traceStatusText = '查询中...'
      this.traceStatus = 'loading'

      this.$request.getHttp({
        url: "/basic/traceDevice",  // ← 替换成你的实际溯源接口
        params: {bm: barcode},
        success: (data) => {
          if (data.code === 200) {
            this.traceResult = data.data || null
            this.showScanner = false           // 成功后隐藏扫描区
            this.traceStatusText = '查询成功'
            this.gunStatus = 'success'
          } else {
            this.traceStatusText = data.msg || '查询失败'
            this.traceStatus = 'error'
            this.traceResult = null
          }
        },
        error: (err) => {
          console.error('溯源查询失败', err)
          this.traceStatusText = '查询失败，请重试'
          this.traceStatus = 'error'
          this.traceResult = null
        }
      })
    },
    getDic() {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: 'rklx'},
        success: (data) => {
          this.rktypeList = data.data

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getcom() {
      this.$request.postHttp({
        url: "/basic/getcom",
        success: (data) => {
          this.comList = data.data

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    formatecid(cid) {
      const found = this.comList.find(item => item.id == cid)
      return found ? found.name : pid || '--'
    },
    formatecktype(cid) {
      const found = this.rktypeList.find(item => item.dictCode == cid)
      return found ? found.dictValue : pid || '--'
    },
    goBack() {
      this.$router.push('/')  // 跳转到根路由（首页）
      // 如果你想带参数或替换历史记录，可以改成：
      // this.$router.replace('/')
      // 或 this.$router.go(-1) 返回上一页（更像“后退”）
    },
    // 公共方法
    gettask() {
      this.$request.postHttp({
        url: "/basic/getcktask",
        success: (data) => {
          this.cktaskList = data.data || []
        },
        error: (error) => {
          console.error("获取任务失败:", error)
        }
      })
    },

    getproductList() {
      this.$request.postHttp({
        url: "/basic/getsp",
        success: (data) => {
          this.productList = data.data || []
        },
        error: (error) => {
          console.error("获取商品列表失败:", error)
        }
      })
    },

    formatepid(pid) {
      const found = this.productList.find(item => item.id == pid)
      return found ? found.name : '--'
    },

    // 手机扫相关方法
    async phoneInitScanner() {
      try {
        this.phoneScanner = new Html5Qrcode("phone-reader", {
          fps: 20,
          qrbox: {width: 400, height: 200},
          aspectRatio: 16 / 9,
          experimentalFeatures: {useBarCodeDetectorIfSupported: true}
        })

        const cams = await Html5Qrcode.getCameras()
        this.phoneCameras = cams
        const backCamera = cams.find(c => c.label.toLowerCase().includes('back') || c.label.toLowerCase().includes('rear'))
        this.phoneCurrentCameraId = backCamera ? backCamera.id : cams[0]?.id

        if (this.phoneCurrentCameraId) {
          this.phoneStatusMessage = '摄像头已准备好'
        } else {
          this.phoneErrorMessage = '未找到可用摄像头'
        }
      } catch (err) {
        this.phoneErrorMessage = '初始化失败：' + err.message
      }
    },

    async phoneStartScanning() {
      if (!this.phoneScanner || !this.phoneCurrentCameraId) return
      if (!this.phoneTaskId) {
        this.phoneStatusMessage = '请先选择出库任务'
        return
      }

      try {
        await this.phoneScanner.start(
            this.phoneCurrentCameraId,
            {
              fps: 30,
              qrbox: {width: 400, height: 200},
              aspectRatio: 16 / 9,
              videoConstraints: {facingMode: 'environment'}
            },
            this.phoneOnScanSuccess,
            () => {
            }
        )
        this.phoneScanning = true
        this.phoneStatusMessage = '正在扫描...'
      } catch (err) {
        this.phoneErrorMessage = '启动失败：' + err.message
      }
    },

    async phoneStopScanning() {
      if (this.phoneScanner && this.phoneScanning) {
        try {
          await this.phoneScanner.stop()
          this.phoneScanning = false
          this.phoneStatusMessage = '扫描已停止'
        } catch (err) {
          console.error(err)
        }
      }
    },

    async phoneSwitchCamera() {
      if (!this.phoneScanning || this.phoneCameras.length < 2) return

      const currentIndex = this.phoneCameras.findIndex(c => c.id === this.phoneCurrentCameraId)
      const nextIndex = (currentIndex + 1) % this.phoneCameras.length
      this.phoneCurrentCameraId = this.phoneCameras[nextIndex].id

      await this.phoneStopScanning()
      await this.phoneStartScanning()
    },

    phoneOnScanSuccess(decodedText) {
      const barcode = decodedText.trim()
      if (!barcode || barcode.length < 6) return

      this.phoneStopScanning()
      this.phoneHandleBarcode(barcode)
    },

    phoneHandleBarcode(barcode) {
      this.phoneStatusMessage = '处理中...'

      this.$request.postHttp({
        url: "/basic/ckOrder",
        params: {id: this.phoneTaskId, bm: barcode},
        success: (data) => {
          if (data.code == 200) {
            this.phoneGetDeviceList()
            this.phoneStatusMessage = '已处理，列表刷新'
          } else {
            this.phoneStatusMessage = data.msg
          }

        },
        error: (err) => {
          console.error('手机扫出库失败', err)
          this.phoneGetDeviceList()
          this.phoneStatusMessage = '处理完成，列表刷新'
        }
      })
    },

    phoneOnTaskChange() {
      if (this.phoneTaskId) this.phoneGetDeviceList()
    },

    phoneGetDeviceList() {
      this.$request.getHttp({
        url: "/basic/getckinfo",
        params: {id: this.phoneTaskId},
        success: (data) => {
          this.phoneDeviceList = data.data || []
        },
        error: (err) => {
          console.error(err)
        }
      })
    },

    // 扫码枪相关方法
    gunOnTaskChange() {
      const task = this.cktaskList.find(t => t.id === this.gunTaskId)
      this.gunSelectedTaskName = task ? task.name : ''
      if (this.gunTaskId) this.gunGetDeviceList()
    },

    gunGetDeviceList() {
      this.$request.getHttp({
        url: "/basic/getckinfo",
        params: {id: this.gunTaskId},
        success: (data) => {
          this.gunDeviceList = data.data || []
        },
        error: (err) => {
          console.error(err)
        }
      })
    },

    gunFocusInput() {
      this.$refs.scanInput?.focus()
    },

    gunHandleScanEnter() {
      const code = this.scanCode.trim()
      if (!code) return
      if (!this.gunTaskId) {
        this.gunStatus = 'warning'
        this.gunStatusText = '请先选择出库任务'
        return
      }

      this.gunStatus = 'loading'
      this.gunStatusText = '处理中...'

      this.$request.postHttp({
        url: "/basic/ckOrder",
        params: {id: this.gunTaskId, bm: code},
        success: (data) => {
          if (data.code == 200) {
            this.gunGetDeviceList()
            this.gunStatus = 'success'
            this.gunStatusText = '已处理，列表刷新'
          } else {
            this.gunStatus = 'error'
            this.gunStatusText = data.msg
          }

        },
        error: (err) => {
          console.error('扫码枪出库失败', err)
          this.gunGetDeviceList()
          this.gunStatus = 'error'
          this.gunStatusText = err.msg
        }
      })

      this.scanCode = ''
      this.$nextTick(() => this.gunFocusInput())
    },

    handleClick(tab) {
      if (tab.name === 'second') {
        this.$nextTick(() => this.gunFocusInput())
      }
    }
  }
}
</script>

<style scoped>
.out-storage-scan {
  padding: 20px;
}

.tab-content {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
}

.scanner-wrapper {
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
  border: 3px solid #409eff;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
}

.reader-container {
  width: 100%;
  aspect-ratio: 2 / 1;
}

.scan-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.scan-line.horizontal {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, #00ff00, transparent);
  animation: scanHorizontal 2.5s infinite linear;
}

@keyframes scanHorizontal {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.controls {
  text-align: center;
  margin: 20px 0;
}

.status {
  margin: 12px 0;
  color: #409eff;
  text-align: center;
  font-size: 16px;
}

.device-section {
  margin-bottom: 30px;
}

.section-title {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
}

/* 扫码枪原有样式 */
.scanner-card {
  padding: 20px;
}

.card-header {
  text-align: center;
  margin-bottom: 20px;
}

.header-emoji {
  font-size: 36px;
  margin-right: 12px;
}

.panel-title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.left-panel, .right-panel {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.scan-input-large {
  width: 100%;
  margin-bottom: 16px;
  font-size: 16px;
}

.current-status {
  text-align: center;
  padding: 20px 0;
  border-radius: 8px;
  margin: 16px 0;
  font-size: 18px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.current-status.success {
  background: #f0f9eb;
  color: #67c23a;
}

.current-status.warning {
  background: #fdf6ec;
  color: #e6a23c;
}

.current-status.error {
  background: #fef0f0;
  color: #f56c6c;
}

.current-status.loading {
  background: #e6f7ff;
  color: #409eff;
}

.status-emoji {
  font-size: 36px;
  margin-right: 12px;
}

.guide-text {
  color: #909399;
  font-size: 13px;
  text-align: center;
  margin: 16px 0;
}

.focus-btn {
  width: 100%;
}

.out-highlight {
  color: #37f41a;
  font-weight: bold;
}

.phone-tab {
  padding: 15px;
}

.tab-title {
  font-size: 18px;
  margin: 0 0 15px;
  text-align: center;
  color: #303133;
}

.task-select-area {
  margin-bottom: 20px;
  text-align: center;
}

.scanner-section {
  margin-bottom: 25px;
}

.scanner-wrapper {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0 auto 15px;
  border: 2px solid #409eff;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
}

.reader-container {
  width: 100%;
  aspect-ratio: 4 / 3; /* 手机端更竖一些 */
}

.controls {
  display: flex;
  gap: 10px;
  margin: 15px 0;
  justify-content: center;
  flex-wrap: wrap;
}

.status-box {
  text-align: center;
  padding: 12px;
  background: #e6f7ff;
  border-radius: 8px;
  color: #409eff;
  font-size: 15px;
  margin: 10px 0;
}

.device-section {
  margin-top: 20px;
}

.list-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #303133;
}

.no-task-tip {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
  font-size: 15px;
  background: #f5f7fa;
  border-radius: 8px;
}

.out-highlight {
  color: #67c23a;
  font-weight: bold;
}

/* 手机端小屏适配 */
@media (max-width: 768px) {
  .controls {

  }

  .controls .el-button {
    width: 30%;
  }
}
</style>